// extracted by mini-css-extract-plugin
module.exports = {"welfare":"index_welfare_3RceZ","header":"index_header_1Ym5K","tab":"index_tab_35sEB","tabItem":"index_tabItem_30T0b","active":"index_active_QsjkI","list":"index_list_2sqF1"};